export const meetupDate = '2026-03-19';
export const meetupStartTime = '18:00';
export const timeZone = 'CET';
export const formName = 'europe-digital-sovereignty-2026-warsaw';
export const logoUrl = 'https://andersenlab.com/?utm_source=sovereignty_warsaw&utm_medium=event';

export const initialCoordinates = {
  lat: 52.23036232591171,
  lng: 20.985765028836198,
};

export const markerSettings = {
  position: initialCoordinates,
  icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/landings_NX/forum-bishkek/location/marker-for-map.svg',
  title: 'Europe: Digital Sovereignty or Dependence?',
  address: 'Rondo Ignacego Daszyńskiego 1\n00-843, Warszaw',
  link: 'https://maps.app.goo.gl/3K91SQ3dCMxuJJ619',
};
